// notificationSlice.ts
import {createSlice} from '@reduxjs/toolkit';
import {AppRootState} from 'store/appStore';

interface NotificationState {
    refreshKey: number; // used to trigger re-render in components
}

const initialState: NotificationState = {
    refreshKey: 0, // incremented to trigger effect in components
};

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        triggerRefresh(state) {
            state.refreshKey += 1;
        },
    },
});

export const {triggerRefresh} = notificationSlice.actions;
export const notificationSliceReducer = notificationSlice.reducer;
export const notificationSliceSelector = (rootState: AppRootState): NotificationState => rootState.notification;
